(function(angular) {
    angular
        .module('repairforms.factory.module')
        .factory('_', Underscore);

    Underscore.$inject = ['$window'];

    function Underscore($window) {
        return $window._;
    }
})(angular);